import { skipToken, useQuery } from "@tanstack/react-query";
import api from "../../../../../api";
import urls from "../../../../../urls";
import type { EdaFilterOptions } from "../../EnergyDataAcquisitionSelectionModal/EnergyDataAcquisitionSelectionModal";

export type EnergyDataAcquisitionFilterOptions = Record<
  string,
  EdaFilterOptions
>;

export function useEnergyDataAcquisitionFilterOptions(projectId?: string) {
  return useQuery({
    queryKey: ["filterOptions", { projectId }],
    queryFn: projectId
      ? () => fetchEnergyDataAcquisitionFilterOptions(projectId)
      : skipToken
  });
}

async function fetchEnergyDataAcquisitionFilterOptions(projectId: string) {
  const response = await api.get<EnergyDataAcquisitionFilterOptions>(
    urls.api.energyDataAcquisitionFilterOptions(projectId)
  );
  return response.data;
}
